// IconeGioco.tsx — v028: le icone dei comandi in partita (esci, audio, segnala), al posto del menu ⋯.
export function IconaEsci() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
      <path d="M10 8l-4 4 4 4M6 12h10" />
    </svg>
  );
}

export function IconaSegnala() {
  // v035: allerta (punto esclamativo), non più la bandierina: si capisce subito che è una cosa seria
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3.2 2.6 19.6a1 1 0 0 0 .87 1.5h17.06a1 1 0 0 0 .87-1.5L12 3.2Z" fill="currentColor" fillOpacity="0.18" />
      <path d="M12 9.5v5" />
      <path d="M12 17.9h.01" strokeWidth="3" />
    </svg>
  );
}

/** v030: effetti sonori del gioco (onde che vibrano attorno a una nota), diverso dal microfono e dal muto. */
export function IconaSuoni({ acceso }: { acceso: boolean }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10.5 16.5V7l5-1.5V15" />
      <circle cx="8.5" cy="16.5" r="2" fill="currentColor" fillOpacity="0.25" />
      <circle cx="13.5" cy="15" r="2" fill="currentColor" fillOpacity="0.25" />
      {acceso ? (
        <>
          <path d="M3.5 8.5l-1.5 2 1.5 2-1.5 2" />
          <path d="M20.5 8.5l1.5 2-1.5 2 1.5 2" />
        </>
      ) : (
        <path d="M3 3l18 18" />
      )}
    </svg>
  );
}

/** v038b: l'altoparlante classico: con le onde (audio acceso) o con la sbarra (audio spento). */
export function IconaAltoparlante({ acceso, dimensione = 22 }: { acceso: boolean; dimensione?: number }) {
  return (
    <svg width={dimensione} height={dimensione} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor" fillOpacity="0.25" />
      {acceso ? (
        <>
          <path d="M15.5 9a4 4 0 0 1 0 6" />
          <path d="M18 6.5a7.5 7.5 0 0 1 0 11" />
        </>
      ) : (
        <path d="M15.5 9.5l5 5M20.5 9.5l-5 5" />
      )}
    </svg>
  );
}

/** v030: «Ha riso!» come faccina che ride (gialla), piccola, in basso a sinistra sul video dell'altro. */
export function IconaRisata() {
  return (
    <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
      <circle cx="16" cy="16" r="14" fill="#FFD60A" stroke="#3a2600" strokeWidth="2" />
      <path d="M8.5 12.5q2-2.5 4 0M19.5 12.5q2-2.5 4 0" fill="none" stroke="#3a2600" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M8 17h16q-1 7-8 7t-8-7z" fill="#3a2600" />
      <path d="M11 21.5q5 3 10 0" fill="none" stroke="#ff5470" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M5.5 13.5q-2 2-.5 4.5M26.5 13.5q2 2 .5 4.5" fill="none" stroke="#3de0ff" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
